import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/creator/useCreatorQueryKeys.ts
var t = e("creator", {
	overview: (e, t) => e === void 0 && t === void 0 ? ["overview"] : [
		"overview",
		e ?? null,
		t ?? null
	],
	linkQr: (e) => ["link-qr", e],
	timeseries: (e) => ["timeseries", e ?? null],
	linkConversions: (e) => ["link-conversions", e],
	linkTimeseries: (e, t) => [
		"link-timeseries",
		e,
		t ?? null
	]
});
//#endregion
export { t as creatorQueryKeys };
